import React from 'react'
import { Card, Flex, Statistic } from 'antd'
import dayjs from 'dayjs'
import {
  ArrowUpOutlined
} from '@ant-design/icons'

export default function SlotsByDayChart ({ slots, boxes, period, box }) {
  const calculateDays = (box) => {
    if (box) {
      return box.days.filter((day) => dayjs(day.date) >= period.start && dayjs(day.date) < period.end)
    } else {
      return boxes.map((b) => b.days).flat().filter((day) => dayjs(day.date) >= period.start && dayjs(day.date) < period.end)
    }
  }

  return (
    <Card>
      <Flex gap='2em'>
        <Statistic title={'Ratio par jour ouvrable'} value={slots.length / calculateDays(box).length} precision={2} />
        <Statistic
          title="Variation par rapport à la semaine dernière"
          value={9.3}
          precision={2}
          styles={{ content: { color: '#3f8600' } }}
          prefix={<ArrowUpOutlined />}
          suffix="%"
        />
      </Flex>
    </Card>
  )
}
